import { useDeviceType } from '@cian/ui-kit';
import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { sendMailingUxfeedbackCampaign } from '../../actions/mailingUxfeedback';
import { setMobileActiveSide } from '../../actions/mobileSide';
import { closeUserCard } from '../../actions/userCard/closeUserCard';
import { ChatHeaderUser } from '../../components/ChatHeader';
import { useCurrentChatCompanionData } from '../../hooks';
import { currentOpenChatIDSelector, hostTypeSelector } from '../../selectors';
import { EDeviceType } from '../../types/deviceType';
import { EHostType } from '../../types/hostType';
import { EMobileLayoutActiveSide } from '../../types/mobileSide';
import { useApplicationContext } from '../../utils/applicationContext';
import { ChatHeaderCallButtonContainer } from '../ChatHeaderCallButtonContainer';
import { ChatHeaderMarkStarredButtonContainer } from '../ChatHeaderMarkStarredButtonContainer';
import { ChatMenuContainer } from '../ChatMenuContainer';
import { CompanionStatusContainer, CompanionTitleContainer, CustomCompanionTitleContainer } from './containers';
import { closeChat } from '../../actions/chatWindow';

export const ChatHeaderUserContainer = () => {
  const {
    config,
    custom: { realDevice },
  } = useApplicationContext();
  const hostType = useSelector(hostTypeSelector);
  const chatId = useSelector(currentOpenChatIDSelector);
  const isCustomHeaderEnabled = config.get<boolean>('frontend-chats.customHeader.Enabled') || false;

  const isIframe = hostType === EHostType.Frame;
  const device = useDeviceType();
  const isMobile = device !== EDeviceType.Desktop;

  const dispatch = useDispatch();

  const companion = useCurrentChatCompanionData(chatId);

  const { companionId } = companion;

  const handleClickBack = () => {
    dispatch(closeUserCard());
    dispatch(setMobileActiveSide(EMobileLayoutActiveSide.Left));
    dispatch(sendMailingUxfeedbackCampaign());
    dispatch(closeChat());
  };

  return (
    <ChatHeaderUser
      showBackButton={isMobile && !isIframe}
      isDesktopIframe={isIframe && realDevice === EDeviceType.Desktop}
      handleClickBack={handleClickBack}
      companionTitle={
        isCustomHeaderEnabled ? (
          <CustomCompanionTitleContainer companionId={companionId} />
        ) : (
          <CompanionTitleContainer companion={companion} />
        )
      }
      callButtonNode={isMobile && !isIframe ? <ChatHeaderCallButtonContainer /> : null}
      chatMenuNode={!isIframe && !isMobile ? <ChatMenuContainer /> : null}
      companionStatus={<CompanionStatusContainer companionId={companionId} />}
      chatStarredNode={<ChatHeaderMarkStarredButtonContainer />}
    />
  );
};
